import ReactDefault from 'react'
import * as React from 'react'
import ReactJSXRuntimeDefault from 'react/jsx-runtime'
import * as ReactJSXRuntime from 'react/jsx-runtime'
import ReactDomDefault from 'react-dom'
import * as ReactDom from 'react-dom'

(window as any).$ReSheet$React$default = ReactDefault;
(window as any).$ReSheet$React = React;
(window as any).$ReSheet$React$JSXRuntime$default = ReactJSXRuntimeDefault;
(window as any).$ReSheet$React$JSXRuntime = ReactJSXRuntime;
(window as any).$ReSheet$ReactDom$default = ReactDomDefault;
(window as any).$ReSheet$ReactDom = ReactDom;